import { gql } from '@apollo/client';

export interface ADD_SCHOOL_TO_CART_TYPE {
  updateViaxCustomerOrder: {
    uid: string;
    wSchoolName: string;
    wSchoolFiceCode: string;
  };
}

export interface ADD_SCHOOL_TO_CART_VARIABLES_TYPE {
  uid: string;
  schoolName: string;
  schoolFiceId: string;
}

export const ADD_SCHOOL_TO_CART = gql`
  mutation wSaveSchoolInfo(
    $uid: String!
    $schoolName: String!
    $schoolFiceId: String!
  ) {
    wSaveSchoolInfo(
      orderUid: $uid
      schoolName: $schoolName
      schoolFiceId: $schoolFiceId
    )
  }
`;
